/*\
|*|
|*|	Syntaxes:
|*|
|*|	* docCookies.setItem(name, value[, end[, path[, domain[, secure[, same-site]]]]])
|*|	* docCookies.getItem(name)
|*|	* docCookies.removeItem(name[, path[, domain[, secure[, same-site]]]])
|*|	* docCookies.hasItem(name)
|*|	* docCookies.keys()
|*|	* docCookies.clear([path[, domain[, secure[, same-site]]]])
|*|
\*/



const makeSetterString = function(sKey, sValue, vEnd, sPath, sDomain, bSecure, vSameSite) {

    let sExpires = "";

    if (vEnd) {

        switch (vEnd.constructor) {

            case Number:

                sExpires = vEnd === Infinity ? "; expires=Fri, 31 Dec 9999 23:59:59 GMT" : "; max-age=" + vEnd;
                break;

            case String:

                sExpires = "; expires=" + vEnd;
                break;

            case Date:

                sExpires = "; expires=" + vEnd.toUTCString();
                break;

        }

    }

    return	encodeURIComponent(sKey) + "=" + encodeURIComponent(sValue) + sExpires + (sDomain ? "; domain=" + sDomain : "") + (sPath ? "; path=" + sPath : "") + (bSecure ? "; secure" : "") + (!vSameSite || vSameSite.toString().toLowerCase() === "no_restriction" ? "" : vSameSite.toString().toLowerCase() === "lax" || Math.ceil(vSameSite) === 1 || vSameSite === true ? "; samesite=lax" : vSameSite.toString().toLowerCase() === "none" || vSameSite < 0 ? "; samesite=none" : "; samesite=strict");

}

const reURIAllowed = /[\-\.\+\*]/g, reCNameAllowed = /^(?:expires|max\-age|path|domain|secure|samesite|httponly)$/i;

const docCookies = {

    "getItem": function (sKey) {

        if (!sKey) { return null; }

        return decodeURIComponent(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" + encodeURIComponent(sKey).replace(reURIAllowed, "\\$&") + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1")) || null;

    },

    "setItem": function (sKey, sValue, vEnd, sPath, sDomain, bSecure, vSameSite) {

        if (!sKey || reCNameAllowed.test(sKey)) { return false; }

        document.cookie = makeSetterString(sKey, sValue, vEnd, sPath, sDomain, bSecure, vSameSite);
        return true;

    },

    "removeItem": function (sKey, sPath, sDomain, bSecure, vSameSite) {

        if (!this.hasItem(sKey)) { return false; }

        document.cookie = makeSetterString(sKey, "", "Thu, 01 Jan 1970 00:00:00 GMT", sPath, sDomain, bSecure, vSameSite);
        return true;

    },

    "hasItem": function (sKey) {

        if (!sKey || reCNameAllowed.test(sKey)) { return false; }

        return (new RegExp("(?:^|;\\s*)" + encodeURIComponent(sKey).replace(reURIAllowed, "\\$&") + "\\s*\\=")).test(document.cookie);

    },

    "keys": function () {

        let aKeys = document.cookie.replace(/((?:^|\s*;)[^\=]+)(?=;|$)|^\s*|\s*(?:\=[^;]*)?(?:\1|$)/g, "").split(/\s*(?:\=[^;]*)?;\s*/);

        for (let nLen = aKeys.length, nIdx = 0; nIdx < nLen; nIdx++) {

            aKeys[nIdx] = decodeURIComponent(aKeys[nIdx]);

        }

        return aKeys;
    },

    "clear": function (sPath, sDomain, bSecure, vSameSite) {

        for (let aKeys = this.keys(), nLen = aKeys.length, nIdx = 0; nIdx < nLen; nIdx++) {

            this.removeItem(aKeys[nIdx], sPath, sDomain, bSecure, vSameSite);

        }

    }

}

export default docCookies


